import { IOfferAnswerSetting, ITableDemandItem, OfferAnswerType } from '@models/winnerSelection/ITableDemand';

export const normalizeOfferAnswerType = (value: string | null | undefined): OfferAnswerType | null => {
    const type = value?.trim().toLowerCase();
    if (!type) return null;

    if (type === 'text' || type === 'string' || type === 'input' || type === 'ввод текста') return 'text';
    if (type === 'select' || type === 'list' || type === 'выбор варианта' || type === 'выбор одного варианта')
        return 'select';
    if (type === 'date' || type === 'дата' || type === 'выбор даты') return 'date';
    if (
        type === 'datetime' ||
        type === 'date-time' ||
        type === 'date_time' ||
        type === 'дата-время' ||
        type === 'дата и время' ||
        type === 'выбор даты и времени'
    )
        return 'datetime';
    if (type === 'money' || type === 'currency' || type === 'decimal' || type === 'деньги') return 'money';
    if (
        type === 'integer' ||
        type === 'int' ||
        type === 'number' ||
        type === 'double' ||
        type === 'целое' ||
        type === 'целые числа' ||
        type === 'число'
    )
        return 'integer';
    if (
        type === 'yesno' ||
        type === 'yes-no' ||
        type === 'yes_no' ||
        type === 'bool' ||
        type === 'boolean' ||
        type === 'да/нет' ||
        type === 'да-нет' ||
        type === 'выбор "да" или "нет"' ||
        type === 'выбор «да» или «нет»' ||
        type === 'выбор да или нет'
    )
        return 'yesno';

    return null;
};

export const getOfferAnswerSetting = (
    row: ITableDemandItem,
    offerAnswerSettings?: IOfferAnswerSetting[] | null,
): IOfferAnswerSetting | null => {
    if (!offerAnswerSettings) return null;

    return (
        offerAnswerSettings.find((s) => s.key === row.answerType) ??
        offerAnswerSettings.find((s) => s.key === row.critId) ??
        null
    );
};

export const getOfferAnswerControlType = (
    row: ITableDemandItem,
    offerAnswerSettings?: IOfferAnswerSetting[] | null,
): OfferAnswerType => {
    const answerSetting = getOfferAnswerSetting(row, offerAnswerSettings);
    return answerSetting?.type ?? normalizeOfferAnswerType(row.answerType) ?? 'text';
};
